import {
  RaThemeOptions,
  defaultLightTheme,
  defaultDarkTheme,
  nanoDarkTheme,
  nanoLightTheme,
  radiantDarkTheme,
  radiantLightTheme,
  houseDarkTheme,
  houseLightTheme,
} from 'react-admin';
import { myThemeDark, myThemeLight } from '../theme';

export type ThemeName = 'mytheme' | 'default' | 'nano' | 'radiant' | 'house';

export interface Theme {
  name: ThemeName;
  light: RaThemeOptions;
  dark: RaThemeOptions;
}

export const themes: Theme[] = [
  { name: 'mytheme', light: myThemeLight, dark: myThemeDark },
  { name: 'default', light: defaultLightTheme, dark: defaultDarkTheme },
  { name: 'nano', light: nanoLightTheme, dark: nanoDarkTheme },
  { name: 'radiant', light: radiantLightTheme, dark: radiantDarkTheme },
  { name: 'house', light: houseLightTheme, dark: houseDarkTheme },
];